import { useLanguage } from "../../../../stores/LanguageStore";
import {
  Button,
  Checkbox,
  Divider,
  Group,
  LoadingOverlay,
  Stack,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { IconArrowLeft, IconCheck } from "@tabler/icons-react";
import { useMemo, useState } from "react";
import { checkoutOvh } from "../../../../api/ovh";
import { getCurrencySymbol } from "../../../../functions/utilFunctions";

const defaultEmailPrice = 1.49;

const OvhStep4 = ({
  setActiveStep,
  domain,
  emails,
  apiKey,
  buyDomain,
  details,
}) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const handleBuy = () => {
    const data = { domain, emails, external_api_key_id: parseInt(apiKey) };

    setLoading(true);
    checkoutOvh(data)
      .then((res) => {
        setActiveStep(4);
      })
      .catch((err) => {
        let message = err.response.data.state_message;
        if (message === "invalid_email_format") {
          setActiveStep(2);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const total = useMemo(() => {
    return (details?.domainPrice || 0) + emails.length * defaultEmailPrice;
  }, [details?.domainPrice, emails.length]);

  const handlePrev = () => {
    setActiveStep(2);
  };

  return (
    <>
      <LoadingOverlay visible={loading} />
      <Title order={2}>{lang.ovh.step4.title}</Title>
      <Text size="md">
        {lang.ovh.step4.text1}
        <br />
        <b>{lang.ovh.step4.text2}</b>
      </Text>

      <Stack
        gap={"xs"}
        style={{ border: "1px solid #00000016", borderRadius: 8 }}
        p={16}
      >
        {buyDomain && (
          <>
            <Group>
              <Text size="lg" flex={1}>
                {lang.ovh.step4.domain}
                <span
                  style={{
                    color: "var(--mantine-color-primary-6)",
                    marginLeft: 16,
                    fontWeight: 600,
                    fontSize: 16,
                  }}
                >
                  {domain}
                </span>
              </Text>

              {details.domainPrice && (
                <Text fw={700} fz={24} c="primary" ta={"right"} lh={1.1} ml={8}>
                  {details.domainPrice}
                  {getCurrencySymbol(details.currencyCode)}{" "}
                  <span style={{ fontSize: 16 }}>
                    {" "}
                    {lang.ovh.step4.per_year}
                  </span>
                </Text>
              )}
            </Group>

            {emails.length > 0 && <Divider />}
          </>
        )}
        {emails.length > 0 && (
          <>
            <Text size="lg">{lang.ovh.step4.emails}</Text>
            {emails.map((email, index) => (
              <Group key={email.id}>
                <Group
                  style={{ border: "1px solid #00000016", borderRadius: 8 }}
                  p={"sm"}
                  flex={1}
                >
                  <Text size="lg">
                    {email.prefix}@{domain}
                  </Text>
                </Group>
                <Text fw={700} fz={24} c="primary" ta={"right"} lh={1} ml={8}>
                  {defaultEmailPrice}€{" "}
                  <span style={{ fontSize: 16 }}>
                    {" "}
                    {lang.ovh.step4.per_month}
                  </span>
                </Text>
              </Group>
            ))}
          </>
        )}
        <Divider mt={"xs"} />
        <Group justify="end">
          <Text fz={22} fw={700}>
            {lang.ovh.step4.total}
          </Text>
          <Text fw={700} fz={28} c="primary">
            {total}€<span> HT</span>
          </Text>
        </Group>
      </Stack>

      <Text size="lg" fw={600}>
        {lang.ovh.step4.no_tax}
      </Text>

      <Checkbox
        checked={confirm}
        onChange={(e) => setConfirm(e.target.checked)}
        label={lang.ovh.step4.confirm}
        size="md"
        mt={"auto"}
        mb={8}
      />

      <Group justify="space-between" gap={32}>
        <Button
          leftSection={<IconArrowLeft />}
          size="md"
          w={150}
          onClick={handlePrev}
          variant="outline"
        >
          {lang.global.back}
        </Button>

        <Tooltip disabled={confirm} label={lang.ovh.step4.please_confirm}>
          <Button
            rightSection={<IconCheck />}
            size="md"
            onClick={handleBuy}
            flex={1}
            disabled={!confirm}
          >
            {lang.ovh.step4.pay_now}
          </Button>
        </Tooltip>
      </Group>
    </>
  );
};

export default OvhStep4;
